import { BaseClass } from "./base";
import { AnnouncementItem } from "./announcementItem";
import { Damage } from "./damage";

export class Movement extends BaseClass {
    public AnnouncementItemProduct: AnnouncementItem;
    public Damages: Array<Damage>;
}


// WEBPACK FOOTER //
// C:/Temp/Avemov/Avemov-Angular/src/app/base/domain/movement.ts